import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function CRM() {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setCustomers([
      { id: 1, name: '张小明', phone: '138****8001', wechat: 'zxm123', level: 'VIP', lastBuy: '2026-04-15', tags: ['高价活跃'] },
      { id: 2, name: '李小虎', phone: '138****8002', wechat: 'lxh456', level: '普通', date: '2026-04-10', tags: ['新客'] },
      { id: 3, name: '王小明', phone: '138****8003', wechat: 'wxq789', level: '会员', lastBuy: '2026-04-08', tags: ['沉默'] },
    ])
    setLoading(false)
  }, [])

  const getLevelBadge = (level) => {
    const colors = { 'VIP': '#fa8c16', '会员': '#1890ff', '普通': '#999' }
    const bg = colors[level] || '#999'
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: bg, color: '#fff' }}>{level}</span>
  }

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>👥 客户管理 (CRM)</h2>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>姓名</th>
              <th style={th}>手机</th>
              <th style={th}>微信</th>
              <th style={th}>等级</th>
              <th style={th}>最近购买</th>
              <th style={th}>标签</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {customers.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{c.name}</td>
                <td style={td}>{c.phone}</td>
                <td style={td}>{c.wechat}</td>
                <td style={td}>{getLevelBadge(c.level)}</td>
                <td style={{ ...td, color: '#999' }}>{c.lastBuy || '-'}</td>
                <td style={td}>
                  {(c.tags || []).map((t, i) => (
                    <span key={i} style={{ padding: '2px 6px', borderRadius: 4, fontSize: 11, background: '#f5f5f5', color: '#666', marginRight: 4 }}>{t}</span>
                  ))}
                </td>
                <td style={td}>
                  <button style={{ ...btn, background: '#1890ff', color: '#fff' }}>详情</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
